﻿function parsleyValidators() {
    const PersonalEmailExpression = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?!gmail\.com|yahoo\.com|cox\.net|msn\.com|rocketmail\.com|verizon\.net|hotmail\.com|live\.com|aol\.com|comcast\.net|outlook\.com|att\.com|att\.net|zoominternet\.net|ymail\.com|me\.com|icloud\.com|mac\.com)(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    const warningLabel = document.getElementById('companyEmailWarning');
    window.parsley.addValidator('personals', {
        validateString: function (value) {
            const returnValue = PersonalEmailExpression.test(value);
            if (returnValue && warningLabel != null) {
                warningLabel.classList.add('d-none');
            }
            else if (warningLabel != null) {
                warningLabel.classList.remove('d-none');
            }
            return returnValue;
        },
        messages: {
            en: 'Company emails only please'
        }
    })
}

parsleyValidators();